/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { TextLoop } from "react-text-loop-next";

import {
  Alert,
  Button,
  Breadcrumb,
  Divider,
  Layout,
  Col,
  Row,
  List,
  Typography,
  Steps,
  Empty,
  Spin,
  Space,
} from "antd";
import { db } from "../../components/firestore";
import { db_user } from "../../components/firestore_user";
import { Link, useParams } from "react-router-dom";
import firebase from "firebase";
import statusColor from "../../components/utils/satus";
const { Content } = Layout;
const { Step } = Steps;

import {
  ArrowLeftOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
const { Title } = Typography;
import functions from "../../components/utils/functions";
import RegisterForm from "./form";
import Platform from "../../components/platforms";
import Contract from "./contract";
import BankAccountModal from "./BankAccountModal";
import { hasBankAccountSubmitted } from "../../components/utils/bankAccount";
import Metric from "./metric";
import MetricV2 from "./metric/v2";
import Submit from "../../components/submit";
import { getDistributionProject } from "../../api/distributionProject";
import { projectHasYoutubePlatform } from "../../components/utils/youtubePlatform";
import LicenseAgreementGateScreen from "./youtube-analytics/LicenseAgreementGateScreen";
import {
  applyYoutubeLicenseSignatureToProject,
  useYoutubeLicenseContract,
} from "./youtube-analytics/useYoutubeLicenseContract";
import { useIsAdmin } from "../../hooks/useIsAdmin";

//workflow : inactive -> incomplete ->  review -> contract/blocked -> live

const checklistStatus = ["incomplete", "blocked", "review"];

/** Maps SQL platform rows from GET /distribution (platforms array). */
function mapProjectPlatformsFromApi(p) {
  if (!p || p.length === 0) return [];
  return p.map((plat) => ({
    id: plat.platform_id,
    status: plat.status,
    link: plat.link,
    msg: plat.msg,
    display_name: plat.display_name || plat.platform_id,
    chart_color: plat.chart_color,
    linked_platform_id: plat.linked_platform_id,
    exclusive: plat.exclusive,
    rev_share: plat.rev_share,
    value_text: plat.value_text,
    mode: plat.mode,
    period_years: plat.period_years,
    payout: plat.payout,
    metric_label: plat.metric_label,
  }));
}

const blocked_status = {
  "access-missing":
    "We do not have the Google Drive access. Please provide the editor access to support@shortedfilms.com.",
  "subtitle-missing":
    "The film is missing subtitles. Please refer the template folder and provide a subtitle file as they are mandatory.",
  "subtitle-burnt":
    "The subtiltes are burnt on the film. Please provide them as a separate file and not on the video.",
  "files-missing":
    "The files are missing. Please provide the files as per the template folder.",
};
const Common = ({ auth_user }) => {
  const [project, updateLeads] = useState({});
  const [loading, toggleLoading] = useState(true);
  const [checklist, updateChecklist] = useState([]);
  const [distribution, updateDistribution] = useState({});
  const [distributionPlatformsLoading, setDistributionPlatformsLoading] =
    useState(false);
  const id = useParams().id;
  const uid = auth_user?.user?.uid;
  const isLive = project.distributionStatus === "live";
  const hasYoutube =
    isLive && projectHasYoutubePlatform(distribution?.platform || []);
  const waitingForYoutubeCheck = isLive && distributionPlatformsLoading;
  const { loaded: adminLoaded, isAdmin } = useIsAdmin(auth_user);
  const bypassContractGate = adminLoaded && isAdmin;

  const {
    contractConfig,
    contractSigned,
    contractGateActive,
    contractSigning,
    handleContractSign,
  } = useYoutubeLicenseContract({
    projectId: id,
    project,
    uid,
    hasYoutube,
    bypassContractGate,
  });

  const onContractSign = async (signerName) => {
    const name = await handleContractSign(signerName);
    if (name) {
      updateLeads((prev) =>
        applyYoutubeLicenseSignatureToProject(prev, uid, name)
      );
    }
  };

  const isValidProject =
    project?.pro === "success" ||
    (project &&
      project.status == "published" &&
      project.rating >= 6.5 &&
      project.country == "in");

  const bankAccountPending =
    !hasBankAccountSubmitted(project) &&
    ["live", "contract-filled"].includes(project.distributionStatus);
  const hasContractLink =
    project.distributionLicense?.fireBaseUrl &&
    ["live", "contract-filled"].includes(project.distributionStatus);

  /** SQL distribution + platforms — only when project is live. No Firestore `distribution` doc. */
  const loadDistributionFromSql = (projectId) => {
    if (!projectId) return;
    setDistributionPlatformsLoading(true);
    getDistributionProject(projectId)
      .then(({ distribution: d, platforms }) => {
        const platformList = mapProjectPlatformsFromApi(platforms);
        updateDistribution(() => {
          if (!d) {
            return { platform: platformList };
          }
          return {
            user_id: d.user_id,
            project_id: d.project_id,
            created_at: d.created_at,
            title: d.title,
            status: d.status,
            platform: platformList,
          };
        });
        if (d && d.title) {
          updateLeads((prev) => ({ ...prev, title: d.title }));
        }
      })
      .finally(() => setDistributionPlatformsLoading(false));
  };

  const movies_load = async () => {
    try {
      const doc = await db_user.collection("projects").doc(id).get();
      const projectData = doc.exists ? doc.data() : null;
      const docChecklist = await db.collection("pages").doc("homepage").get();
      docChecklist.data() && updateChecklist(docChecklist.data());

      updateLeads(projectData || {});
      updateDistribution({});
      setDistributionPlatformsLoading(false);
      if (projectData?.distributionStatus === "live") {
        loadDistributionFromSql(id);
      }
      if (projectData && auth_user.user && auth_user.user.uid) {
        db_user
          .collection("trackers")
          .doc("distribution")
          .update({
            users: firebase.firestore.FieldValue.arrayUnion(auth_user.user.uid),
            projects: firebase.firestore.FieldValue.arrayUnion(doc.id),
          });
      }
      toggleLoading(false);
    } catch (error) {
      console.log(error);
      updateLeads({});
      updateDistribution({});
      setDistributionPlatformsLoading(false);
      toggleLoading(false);
    }
  };
  useEffect(() => {
    if (auth_user?.user?.uid) {
      movies_load();
    }
  }, [auth_user?.user?.uid, id]);

  const updateStatus = async () => {
    const doc = await db_user.collection("projects").doc(id).get();
    updateLeads(doc.data());
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ padding: "0 0px 24px" }}>
        <Content
          className="site-layout-background"
          style={{
            margin: 0,
            minHeight: 280,
          }}
        >
          <Divider />
          {loading || (waitingForYoutubeCheck && !bypassContractGate) ? (
            <div className="vc-spin-wrap">
              <Spin />
            </div>
          ) : !isValidProject ? (
            <Empty
              status="500"
              title="You have no projects"
              subTitle="Start submitting now!"
              description={<span>Not a valid project</span>}
            />
          ) : contractGateActive ? (
            <LicenseAgreementGateScreen
              breadcrumbSlot={
                <>
                  <Breadcrumb.Item>
                    <Link to="/">My Projects</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{project.title}</Breadcrumb.Item>
                </>
              }
              backHref="/"
              title={project.title}
              titleLevel={2}
              subtitle="Sign the license agreement below to access your project."
              contractConfig={contractConfig}
              contractSigned={contractSigned}
              contractGateActive={contractGateActive}
              contractSigning={contractSigning}
              onContractSign={onContractSign}
            />
          ) : (
            <Row>
              <Col
                xs={{ span: 24 }}
                lg={{
                  span: project.distributionStatus === "live" ? 16 : 12,
                  offset: project.distributionStatus === "live" ? 4 : 6,
                }}
                className="vc-panel"
                style={{
                  padding: "24px",
                  textAlign: "left",
                }}
              >
                <>
                  {checklist.notifications && (
                    <Alert
                      banner
                      message={
                        <TextLoop mask noWrap={false}>
                          {checklist.notifications.map((item, index) => (
                            <div key={index}>{item}</div>
                          ))}
                        </TextLoop>
                      }
                      type="info"
                      style={{
                        marginBottom: "24px",
                        height: window.innerWidth < 530 ? "76px" : "40px",
                      }}
                    />
                  )}
                  <Breadcrumb separator="/">
                    <Breadcrumb.Item>
                      <Link to={`/`}>My Projects</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>{project.title}</Breadcrumb.Item>
                  </Breadcrumb>
                  <Divider />
                  <div style={{ display: "flex", alignItems: "baseline" }}>
                    <Link to={`/`}>
                      {" "}
                      <ArrowLeftOutlined
                        style={{ fontSize: 20, marginRight: 16 }}
                      />
                    </Link>
                    <Title level={2}>{project.title}</Title>
                  </div>
                  {!["contract", "live"].includes(
                    project.distributionStatus
                  ) && (
                    <>
                      <img
                        alt={project.title}
                        src={
                          project.photo_url
                            ? project.photo_url
                            : `https://i.ytimg.com/vi/${functions.get_videoID(
                                project.video_url
                              )}/maxresdefault.jpg`
                        }
                        width="100%"
                      />
                      <Divider />
                    </>
                  )}

                  {project.distributionStatus !== "live" && checklist.steps && (
                    <Steps
                      current={
                        project.distributionStatus === "live"
                          ? 2
                          : project.distributionStatus === "contract"
                          ? 1
                          : 0
                      }
                      direction={
                        window.innerWidth < 530 ? "vertical" : "horizontal"
                      }
                    >
                      {checklist.steps.map((item, index) => (
                        <Step
                          key={index}
                          title={item.title}
                          description={item.description}
                        />
                      ))}
                    </Steps>
                  )}
                  {(hasContractLink || bankAccountPending) && (
                    <>
                      <Divider />
                      <Space wrap>
                        {hasContractLink && (
                          <a
                            href={project.distributionLicense.fireBaseUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Button>View Contract</Button>
                          </a>
                        )}
                        {bankAccountPending && (
                          <BankAccountModal
                            projectId={id}
                            onSubmitted={(fields) =>
                              updateLeads((prev) => ({
                                ...prev,
                                distributionLicense: {
                                  ...(prev.distributionLicense || {}),
                                  ...fields,
                                },
                              }))
                            }
                          />
                        )}
                      </Space>
                    </>
                  )}
                  <Divider />
                  <Alert
                    message={
                      statusColor[project.distributionStatus || "inactive"]
                        .title
                    }
                    description={
                      <>
                        {project.distributionStatus == "blocked" &&
                        project.distributionBlockedReason
                          ? `${
                              blocked_status[project.distributionBlockedReason]
                            } Let us know at support@shortedfilms.com once you have made the changes.`
                          : statusColor[
                              project.distributionStatus || "inactive"
                            ].description}
                      </>
                    }
                    type={
                      statusColor[project.distributionStatus || "inactive"].type
                    }
                    showIcon
                    style={{
                      fontFamily: "Raleway",
                      marginTop: "24px",
                      marginBottom: "24px",
                    }}
                  />
                  {project.distributionStatus === "contract" && (
                    <Contract project={project} />
                  )}
                  {project.distributionStatus === "live" && (
                    <Platform
                      distribution={distribution}
                      loading={distributionPlatformsLoading}
                    />
                  )}
                  {project.distributionStatus === "live" &&
                    distribution?.platform &&
                    projectHasYoutubePlatform(distribution.platform) && (
                      <>
                        <Divider />
                        <Link to={`/project/${id}/youtube-analytics`}>
                          <Button type="default">
                            YouTube revenue (estimates · ₹)
                          </Button>
                        </Link>
                      </>
                    )}
                  {project.distributionStatus === "live" &&
                    distribution &&
                    distribution.platform &&
                    distribution.platform.filter((item) =>
                      ["live", "offline"].includes(item.status)
                    ).length > 0 && (
                      <>
                        {distribution.title === "Dhundasas" ? (
                          <Metric
                            distribution={distribution}
                            lastUpdated={null}
                          />
                        ) : (
                          <MetricV2
                            distributionProjectId={id}
                            distribution={distribution}
                          />
                        )}
                      </>
                    )}
                  <Divider />
                  {checklistStatus.includes(project.distributionStatus) && (
                    <>
                      <b>[IMPORTANT] </b>The folder structure should be in the
                      following format -{" "}
                      <a
                        href={`${checklist.checklist_drive}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Download Template
                      </a>
                      <Divider />
                    </>
                  )}
                  {(!project.distributionStatus ||
                    project.distributionStatus === "inactive" ||
                    project.distributionStatus === "incomplete") && (
                    <>
                      <RegisterForm
                        auth_user={auth_user}
                        status={project.distributionStatus}
                        uid={id}
                        updateStatus={updateStatus}
                        project={project}
                      />
                      <Divider />
                    </>
                  )}
                  {checklistStatus.includes(project.distributionStatus) && (
                    <>
                      <Title level={4}>Checklist</Title>
                      {checklist.checklist_drive && (
                        <List
                          itemLayout="horizontal"
                          dataSource={checklist.checklist}
                          renderItem={(item, index) => (
                            <List.Item>
                              <List.Item.Meta
                                avatar={
                                  project.checklist &&
                                  project.checklist.split("")[index] == 1 ? (
                                    <CheckCircleFilled
                                      style={{ fontSize: 20, color: "green" }}
                                    />
                                  ) : (
                                    <CloseCircleFilled
                                      style={{ fontSize: 20, color: "grey" }}
                                    />
                                  )
                                }
                                title={item.title}
                                description={item.description}
                              />
                            </List.Item>
                          )}
                        />
                      )}
                    </>
                  )}
                </>
              </Col>
            </Row>
          )}
        </Content>
      </Layout>
      {project &&
        project.distributionStatus !== "contract" &&
        !contractGateActive && (
          <Row>
            <Submit />
          </Row>
        )}
    </Layout>
  );
};
export default Common;
